import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { BrowserRouter } from "react-router-dom";
import stores from "./Stores";
import { Provider } from "react-redux";
import RouterPage from "./Routers";
import "./Utils/i18n.js";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <BrowserRouter>
    <Provider store={stores}>
      <RouterPage />
      <ToastContainer />
    </Provider>
  </BrowserRouter>
  // </React.StrictMode>
);
